import {Injectable, Inject} from 'ng-metadata/core';
import {preventStateReload} from '../../infra/annotations';



@Injectable()
export class ChangeLangService {
        
    private UPDATE_DB_URL: string;
    private _selectedLanguage: string;
    
    constructor(@Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs,
                @Inject('$location') private $location,
                @Inject('I18nService') private i18nService) {
        this.UPDATE_DB_URL= restBaseURLs.userSettingsBaseURL;
    }
    
    
    updateUserLanguage(view, language) {
        let payload= this.buildPaylod(view, language);
        return this.$http.post(this.UPDATE_DB_URL, payload); 
    }
    
    private buildPaylod(view, language){
         let payload= {
               'vid': view,
               'interface-language':language
         };
         return payload;
    }
    
    public addLangParamToUrl(lang){
        let searchParams= this.$location.search();
        if (searchParams.lang !== lang){
            this.changeUrl(lang);
        }
    }
    
    @preventStateReload
    private changeUrl(lang){
        let searchParams= this.$location.search();
        searchParams.lang= lang;
        this.$location.search(searchParams).replace();
    }
    
    public get direction(){
        return this.i18nService.direction;
    }
    public getPersonalSettingsFromDBPromise(vid){
        let userDetailsUrl = this.restBaseURLs.userSettingsBaseURL + '?vid=' + vid;
        let promise =  this.$http({
            method: 'GET',
            url: userDetailsUrl,
        })
        return promise;
    }

    get selectedLanguage(){
        return this._selectedLanguage;
    }

    set selectedLanguage(value){
        this._selectedLanguage = value;
    }

}
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/lang/changeLang.service.ts